import { Stack } from 'expo-router';

export default function QuestionStructureLayout() {
    return <Stack screenOptions={{ headerShown: false }} />;
}
